import { api } from "../api";

export function categoryFilter() {
  return {
    modalOpen: false,
    mainCategoryIdSelected: null,
    mainCategoryPath: null,
    categoryLevels: [],
    openModal(categoryId, hasChildren, href) {
      hasChildren = (hasChildren === true || hasChildren === 'true');
      if (!hasChildren && href) {
        window.location.href = href
      } else {
        this.mainCategoryPath = href;
        this.modalOpen = true;
        this.$dispatch('category', { category: categoryId });
      }
    },
    handleMainCategorySelect(event) {
      const selectedOption = event.target.selectedOptions[0];
      const hasChildren = selectedOption.getAttribute('data-has-children') === 'true';
      const href = selectedOption.getAttribute('data-href');

      if (!hasChildren && href) {
        window.location.href = href
      } else {
        this.mainCategoryPath = href;
        this.initFirstCategoryLevel();
      }
    },
    async initFirstCategoryLevel() {
      if (!this.mainCategoryIdSelected) {
        this.categoryLevels = [];
        return;
      }

      const categories = await this.getCategoriesByType(this.mainCategoryIdSelected);
      this.categoryLevels = [{
        options: categories,
        selected: ''
      }];
    },
    async onCategorySelect(levelIndex) {
      const selectedId = this.categoryLevels[levelIndex].selected;
      const selectedCategory = this.categoryLevels[levelIndex].options.find((category) => category.id == selectedId);

      if (selectedCategory.hasChildren) {
        this.categoryLevels = this.categoryLevels.slice(0, levelIndex + 1);

        if (!selectedId) return;

        const children = await this.getCategoriesByType(selectedId);

        if (children.length > 0) {
          this.categoryLevels.push({
            options: children,
            selected: ''
          });
        }
      } else {
        const subCategoryPath = this.categoryLevels.reduce((href, categoryLevel) => {
          return href += categoryLevel.options.find((category) => category.id == categoryLevel.selected).href;
        }, '');
        window.location.href = this.mainCategoryPath + subCategoryPath;
      }
    },
    async getCategoriesByType(parentCategoryId = 0) {
      return await api.post(
        'extension/module/category_search/categories',
        `&parentCategoryId=${parentCategoryId}`)
    }
  }
}